import { Select as Selection, FormControl, InputLabel, MenuItem, FormHelperText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: '95%',
        maxWidth: '100%',
    },
    selectRoot: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));

export const Select = (props) => {
    const { label, value, onChange, options, error, helperText, className, disabled=false, required=false } = props;
    const classes = useStyles();
    return (
        <FormControl variant="outlined" className={classes.formControl + " " + className} error={error} required={required} >
            <InputLabel id={label}>{label}</InputLabel>
            <Selection
                {...props}
                value={value}
                onChange={onChange}
                label={label}
                disabled={disabled}
                fullWidth
                className = { classes.selectRoot }
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    getContentAnchorEl: null,
                    ...(props.MenuProps || {}),
                }}
            >
                {
                    options.map(v => <MenuItem key={v.value} value={v.value}>{v.label}</MenuItem>)
                }
            </Selection>
            {error &&  <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
}